import axios from 'axios'

/** 发送短信验证码 **/
var sendSms = function(number,mobilePhone,callback,errorback){
	axios({
	    method: 'POST',
	    url:'/user/sendPhoneCode',
		params:{
			mobile:mobilePhone,
			number:number
		},
	}).then((res)=>{
			if(res.data.code==1000){
				// 成功回调
				callback&&callback(res.data);
			}else{
				callback&&callback(res.data);
			}
	}).catch((err)=>{
		//回调错误信息
		errorback&&errorback('网络异常，请稍后重试');
	})
}

/*** 短信验证码倒计时 ***/
var phoneSeconds = function(callback,errorback){
	var getCode = document.getElementById("getCode");
	var times=60;
	getCode.innerHTML = times + 's';
	var inter = setInterval(function () {
	    if (times > 1) {
	        times--;
	         getCode.disabled=true;
			 getCode.innerHTML = times + 's';
	    } else {
	        clearInterval(inter);
			getCode.disabled=false;
	        getCode.innerHTML = '获取验证码';
	    }
	}, 1000);
}


export {
	sendSms,
	phoneSeconds,
}